import { useContext, useEffect, useState, useMemo } from 'react'
import { EventDataContext } from 'src/store/events/Store'
import { FightDataContext } from 'src/store/fights/Store'
import { ItemDataContext } from 'src/store/items/Store'
import { NPCDataContext } from 'src/store/npcs/Store'

const useAPIDataLoader = () => {
  const { events } = useContext(EventDataContext)
  const {fights } = useContext(FightDataContext)
  const { NPCs } = useContext(NPCDataContext)
  const { items } = useContext(ItemDataContext)
  
  const [isAPIDataLoaded, setApiDataLoaded] = useState(false)

  const isEventsLoaded = useMemo(() => Object.keys(events).length > 0, [events])
  const isFightsLoaded = useMemo(() => Object.keys(fights).length > 0, [fights])
  const isNPCsLoaded = useMemo(() => Object.keys(NPCs).length > 0, [NPCs])
  const isItemsLoaded = useMemo(() => Object.keys(items).length > 0, [items])

  useEffect(() => {
    if (isEventsLoaded && isFightsLoaded && isNPCsLoaded && isItemsLoaded) {
      setApiDataLoaded(true)
    }
  }, [isEventsLoaded, isFightsLoaded, isNPCsLoaded, isItemsLoaded])

  return isAPIDataLoaded
}

export default useAPIDataLoader
